import {Typography} from 'components/Typography';
import {FC} from 'react';
import style from './style.module.scss';
import {formatRating} from 'core/helpers';

interface IProps {
    code: string;
    value: number;
}

export const ProductRatingsItem: FC<IProps> = ({code, value}) => {
    return (
        <button className={style.main} type={'button'}>
            <Typography variant={'label-14-r'}>{`${code} ${formatRating(value)}`}</Typography>
        </button>
    );
};
